import { faFileLines, faSquareList } from "@fortawesome/pro-solid-svg-icons";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { lazyRouteWithGuards } from "../../components/Routes/Functions/LazyRouteFunction";
import { createLazyRoleCheckGuard } from "../../components/Routes/Guards/LazyRoleCheckGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { IFeature } from "../iFeature";

const requiredRole = AppRole.SummarizationFeature;

export const summaryFeature: IFeature = {
  requiredRole,
  route: {
    path: RouteConstants.Summary,
    lazy: lazyRouteWithGuards({
      importer: () => import("./SummaryPage"),
      componentName: "SummaryPage",
      guards: [createLazyRoleCheckGuard(requiredRole)],
    }),
  },
  menuItem: {
    id: "summary",
    label: translationKeys.feature.summary.link,
    breadCrumbTitle: translationKeys.feature.summary.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Summary].join("/")}`,
    path: RouteConstants.Summary,
    showFooter: true,
    hasSideBar: false,
    fontAwesomeIcon: faSquareList,
  },
  card: (
    <FeatureCard
      featureKey="summary"
      featureIcon={faSquareList}
      buttonIcon={faFileLines}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Summary}
    />
  ),
};
